import { render } from "./walletPcIndex.vue?vue&type=template&id=b9a19694"
import script from "./walletPcIndex.vue?vue&type=script&lang=js"
export * from "./walletPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__